import { Location } from '@medplum/fhirtypes';
import { Flex, Text } from '@mantine/core';
import { ResourceInput } from '@medplum/react';
import { TIMEZONE_EXTENSION } from '@bariendo/lib/extensions';
import { getExtensionValue } from '@medplum/core';
import { timezoneToFriendlyLabel } from '../utils/common';

function LocationSelect({ resource }: { resource: Location }) {
  const state = resource.address?.state;
  const timezone = getExtensionValue(resource, TIMEZONE_EXTENSION) as string | undefined;
  const timezoneLabel = timezone ? timezoneToFriendlyLabel(timezone) : undefined;

  return (
    <Flex gap="xs" align="start" direction="column">
      <Text>
        {resource.name}
        {state ? `, ${state}` : ''}
      </Text>
      {timezoneLabel && (
        <Text size="xs" c="gray">
          Timezone: {timezoneLabel}
        </Text>
      )}
    </Flex>
  );
}

interface LocationInputProps {
  value: Location | null;
  onChange: (resource: Location | null) => void;
  disabled?: boolean;
  required?: boolean;
}

export function LocationInput({ value, onChange, disabled, required = true }: LocationInputProps) {
  return (
    <ResourceInput
      label="Location"
      name="location"
      resourceType="Location"
      onChange={(resource) => onChange((resource as Location) || null)}
      placeholder="Select location"
      defaultValue={value ?? undefined}
      disabled={disabled}
      itemComponent={(props: { resource: Location }) => <LocationSelect resource={props.resource} />}
      searchCriteria={{ _count: '50' }}
      required={required}
    />
  );
}
